module.exports = __webpack_public_path__ + "static/media/precision.cd466ef6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/precision.svg
// module id = 2319
// module chunks = 0